import { useState } from "react";
import { notification } from "antd";

import { AssessmentInsightsHttpService } from "@/modules/assessments/services/assessment-insights-http.service";
import { getFriendlyBlobErrorMessage } from "@/shared/services/http";
import { downloadBlob, getFilenameFromContentDisposition } from "@/shared/utils/download.utils";
import { Button, ButtonColorType, ButtonSize } from "@/ui-components/commonComponents/Button/Button";
import { ReactComponent as DownloadSVG } from "@/assets/icons/feather-icons/download.svg";

interface InsightsExportButtonProps {
  assessmentId: number;
  startDate?: string;
  endDate?: string;
}

export function InsightsExportButton({ assessmentId, startDate, endDate }: InsightsExportButtonProps) {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const response = await AssessmentInsightsHttpService.exportAssessmentInsights({
        assessmentId,
        startDate,
        endDate,
      });
      const filename =
        getFilenameFromContentDisposition(response.headers["content-disposition"]) ??
        `insights_${assessmentId}_export_${new Date().getTime()}.csv`;

      downloadBlob(response.data, filename);
      notification.success({ message: "Successfully exported." });
    } catch (error) {
      notification.error({
        message: (await getFriendlyBlobErrorMessage(error)) ?? "Oops, something went wrong. Please try again.",
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      colorType={ButtonColorType.light}
      buttonSize={ButtonSize.XSmall}
      icon={<DownloadSVG aria-hidden="true" />}
      isLoading={isExporting}
      onClick={handleExport}
    >
      Insights Export
    </Button>
  );
}
